import React from 'react';
import ReactDOM from 'react-dom';
import Home from '../Home'
import WebpackerReact from 'webpacker-react'

WebpackerReact.setup({Home})
